import {RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle} from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private storedRoutes = new Map<string | undefined, DetachedRouteHandle>();


  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.data?.reuse;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    this.storedRoutes.set(route.routeConfig?.path, handle);
  }


  shouldAttach(route: ActivatedRouteSnapshot): boolean {

    if (this.storedRoutes.get(route.routeConfig.path)) {
      const contractorData = window.history.state?.contractor?.contractorData;
      const address = {
        name: contractorData?.name,
        taxNumber: contractorData?.payer?.vatNumber,
        address: contractorData?.streetName,
        addressHouseNO: contractorData?.houseNO,
        addressFlatNO: contractorData?.flatNO,
        postalCodeAndCity: contractorData?.zipCode + ' ' + contractorData?.city,
        phone: contractorData?.contactPerson
      };

      const place = {
        name: contractorData?.name,
        street: contractorData?.streetName,
        houseNo: contractorData?.houseNO,
        flatNo: contractorData?.flatNO,
        city: contractorData?.city,
        zipCode: contractorData?.zipCode,
        country: contractorData?.country,
        commercialNetworkId: contractorData?.commercialNetworkId,
        contactPerson: contractorData?.contactPerson,
        settings: {
          emailNotification: contractorData?.settings.emailNotification,
          textNotification: contractorData?.settings.textNotification,
          alwaysNotify: contractorData?.settings.alwaysNotify
        },
        payer: {
          vatNumber: contractorData?.payer.vatNumber,
          isVatPayer: contractorData?.payer.isVatPayer,
          contractType: contractorData?.payer.contractType
        }
      }

      switch (window.history.state?.contractor?.place) {

        case Place.Recipient: {
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.recipientAddress = address;
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.shipmentForms.orderDataFormGroup.get('recipient').setValue(place);
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.onPlaceChanged({
            id: window.history.state?.contractor?.id,
            zipCode: window.history.state?.contractor.contractorData?.zipCode,
            contractorData: window.history.state?.contractor.contractorData,
            placeType: Place.Recipient
          });
          break;
        }
        case Place.Load: {
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.loadingAddress = address;
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.shipmentForms.routeFormGroup.get('loadingPlace').setValue(place);
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.onPlaceChanged({
            id: window.history.state?.contractor?.id,
            zipCode: window.history.state?.contractor.contractorData?.zipCode,
            contractorData: window.history.state?.contractor.contractorData,
            placeType: Place.Load
          });
          break;
        }
        case Place.Delivery: {
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.deliveryAddress = address;
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.shipmentForms.routeFormGroup.get('deliveryPlace').setValue(place);
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.onPlaceChanged({
            id: window.history.state?.contractor?.id,
            zipCode: window.history.state?.contractor.contractorData?.zipCode,
            contractorData: window.history.state?.contractor.contractorData,
            placeType: Place.Delivery
          });
          break;
        }
        case Place.DefaultAddress: {
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.defaultAddress = address;
          this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.changeDefaultAddress({result: contractorData});
          break;
        }
        case Place.CashOnDelivery: {
            this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.paymentStep.returnAddressValue.address = address;
            this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.paymentStep.codAddress.address = address;
            this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.paymentStep.otherCodAddress.address = address;
            this.storedRoutes.get(route.routeConfig.path)['componentRef'].instance.paymentStep.onReturnAddressChanged();         
          break;
        }
      }
    }

    return !!route.routeConfig && !!this.storedRoutes.get(route.routeConfig.path) && window.history.state.reusePage;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storedRoutes.get(route.routeConfig?.path) as DetachedRouteHandle;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}


enum Place {
  Recipient,
  Load,
  Delivery,
  CustomClearancePlace,
  DefaultAddress,
  CashOnDelivery
}
